<template>
  <td
    @dblclick="startEditing"
    :class="{ 'cell-edit':!disabled, 'text-white': bgColor}"
    :style="styles"
  >
    <vx-tooltip :delay="tooltipDelay" :text="tooltipText" :tooltipPosition="tooltipPosition">
      <template v-if="!isEditing">
        <feather-icon v-if="icon"
        :icon="icon"
        :svgClasses="['h-5' ,'w-5',iconTextColor]"
        />
        {{ value ? prefix : ''}} {{ value ? showValue : '-' }}
        </template>
      <template v-else>
        <vx-input-group>
          <vs-input
            :type="type"
            v-model="data.value"
            @keypress.enter="update"
            @keyup.esc="stopEditing"
            :min="minField"
            max="9999999999"
            @keypress="validate"
            name="inputValue"
            v-validate="validateRules"
          />
          <vs-col vs-w="12">
            <span
              class="text-danger text-sm"
              v-show="errors.has('inputValue')"
            >{{ errors.first('inputValue') }}</span>
          </vs-col>
        </vx-input-group>
      </template>
    </vx-tooltip>
  </td>
</template>

<script>
export default {
  props: {
    id: [String, Number],
    column: String,
    value: [String, Number],
    type: {
      type: String,
      default: 'text'
    },
    format: {
      type: String,
      default: 'text'
    },
    validateRules: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: null
    },
    minField: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      required: '',
    },
    tooltipDelay: {
      type: String,
      default: '1.5s'
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    },
    tooltipText: {
      type: String,
      default: null
    },
    disabled: {
      default: false,
      type: Boolean
    },
    width:{
      type:String,
      default:''
    },
    icon:{
      type:String,
    },
    iconTextColor:{
      type:String
    }
  },
  data: () => ({
    isEditing: false,
    data: {
      id: null,
      column: '',
      value: ''
    },
  }),
  computed: {
    showValue() {
      if (this.format === 'number') {
        return this.formatNumber(this.value)
      }
      if (this.format === 'decimal') {
        return this.formatNumber(this.value, 2)
      }
      return this.value;
    },
    styles(){
       if(this.width != ''){
        return {'background-color':this.bgColor,width:this.width}
      }else{
        return {'background-color':this.bgColor}
      }
    }
  },
  methods: {
    startEditing() {
      if (this.disabled) return
      if (!this.isEditing) {
        this.isEditing = true
        this.data.id = this.id
        this.data.column = this.column
        this.data.value = this.value

      }
    },
    stopEditing() {
      this.isEditing = false
    },
    update() {
      if(!this.errors.has('inputValue')){
        this.stopEditing()
        if (this.value !== this.data.value) {
          this.$emit('update', this.data)
        }
        return
      }
      console.log('Error Validations')
      return
    },
    validate(event) {
      if (this.max !== null && this.data.value !== null) {
        if (this.data.value.length >= this.max) {
          event.preventDefault()
        }
      }
    },
  }
}
</script>

<style>
</style>